import classNames from 'classnames'
import React from 'react'

export const Separator: React.FC<{ className?: string; onClick?: () => void }> = props => (
    <div {...props} className={classNames(props.className)} />
)
